import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter } from 'lucide-react';
import { motion } from 'framer-motion';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  return (
    <footer className="bg-secondary text-secondary-foreground mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <motion.div {...fadeInUp} className="space-y-4">
            <img
              src="/logolaconvencion.png"
              alt="Centro Comercial La Convención"
              className="h-16 w-auto brightness-0 invert"
            />
            <p className="text-sm text-secondary-foreground/80">
              Tu destino de compras favorito. Más de 100 locales comerciales esperando por ti.
            </p>
          </motion.div>

          <motion.div {...fadeInUp} transition={{ delay: 0.1 }}>
            <h3 className="font-heading font-semibold text-lg mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-primary transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/locales" className="text-sm hover:text-primary transition-colors">
                  Directorio de Locales
                </Link>
              </li>
              <li>
                <Link to="/eventos" className="text-sm hover:text-primary transition-colors">
                  Eventos
                </Link>
              </li>
            </ul>
          </motion.div>

          <motion.div {...fadeInUp} transition={{ delay: 0.2 }}>
            <h3 className="font-heading font-semibold text-lg mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <MapPin size={18} className="flex-shrink-0 mt-0.5" />
                <span>Centro Comercial La Convención<br />Medellín, Colombia</span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Phone size={18} className="flex-shrink-0" />
                <span>604 561 3675</span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Mail size={18} className="flex-shrink-0" />
                <span>info@cclaconvencion.com</span>
              </li>
            </ul>
          </motion.div>

          <motion.div {...fadeInUp} transition={{ delay: 0.3 }}>
            <h3 className="font-heading font-semibold text-lg mb-4">Síguenos</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/laconvencioncentrocomercial"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-lg hover:bg-primary transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/laconvencioncentro"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-lg hover:bg-primary transition-colors"
              >
                <Instagram size={20} />
              </a>
            </div>
          </motion.div>
        </div>

        <motion.div
          {...fadeInUp}
          transition={{ delay: 0.4 }}
          className="mt-12 pt-8 border-t border-white/10 text-center text-sm text-secondary-foreground/70"
        >
          <p>
            &copy; {currentYear} Centro Comercial La Convención. Todos los derechos reservados.
          </p>
          <p>
            Creado con <span className="text-primary">❤️</span> por <a href="https://www.colombiaws.com" target="_blank" rel="noopener noreferrer">www.colombiaws.com</a>
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;